import {Divider} from 'antd'

import commonStyles from '../styles.module.scss'
import {
  Form,
  FormItem,
  InputAmount,
  Text,
  Box,
  Button,
  useForm,
  useWatch,
} from 'common/components'
import {useInputFocus} from 'common/hooks'
import {FIELD_RULES} from 'common/constants'
import {formatMoney} from 'common/helpers'
import {useUpdateRequest, usePassRequestMilestone, isMilestonePassed} from '..'

interface OfferFeesFormProps {
  request: any
  onClose: () => void
}

export default function OfferFeesForm({request, onClose}: OfferFeesFormProps) {
  const {
    mutate: passRequestMilestone,
    isMutating: isPassRequestMilestoneMutating,
  } = usePassRequestMilestone(request.uuid, 'offer-signed', onClose)
  const {mutate: updateRequest, isMutating: isUpdateRequestMutating} =
    useUpdateRequest(request.uuid, () => {
      isMilestonePassed('offer-signed', request)
        ? onClose()
        : passRequestMilestone()
    })
  const [form] = useForm()
  const legalFeeAmountValue = useWatch('legalFeeAmount', form)
  const brokerageFeeAmountValue = useWatch('brokerageFeeAmount', form)
  const inputRef = useInputFocus()

  const handleFinish = ({brokerageFeeAmount, ...values}: any) => {
    const newValues = {
      ...values,
      brokerageFeeAmount: brokerageFeeAmount ?? 0,
    }
    updateRequest(newValues)
  }

  const initialValues: any = {
    applicationFeeAmount: request.applicationFeeAmount,
    brokerageFeeAmount: request.brokerageFeeAmount,
    legalFeeAmount: request.legalFeeAmount,
  }
  if (process.env.NODE_ENV === 'development') {
    initialValues.applicationFeeAmount= initialValues.applicationFeeAmount || 5600;
    initialValues.brokerageFeeAmount  = initialValues.brokerageFeeAmount || 2100;
    initialValues.legalFeeAmount      = initialValues.legalFeeAmount || 4500;
  }

  const facilityLimit = formatMoney(
    request.loanValue + legalFeeAmountValue + (brokerageFeeAmountValue ?? 0),
    {
      cents: true,
    }
  )

  const isRequestApproved = (request?.status === "approved")

  return (
    <Form
      className={commonStyles.requestForm}
      form={form}
      initialValues={initialValues}
      onFinish={handleFinish}
    >
      <div className={commonStyles.requestFormFields}>
        <FormItem
          name="applicationFeeAmount"
          label="Application fee*"
          rules={!isRequestApproved ? amountFieldRules:amountFieldRules0}
        >
          <InputAmount ref={inputRef} min={0} />
        </FormItem>
        <FormItem name="brokerageFeeAmount" label="Broker fee">
          <InputAmount min={0} />
        </FormItem>
        <FormItem
          name="legalFeeAmount"
          label="Est. legal fee*"
          rules={!isRequestApproved ? amountFieldRules:amountFieldRules0}
        >
          <InputAmount min={0} />
        </FormItem>
      </div>
      <Divider />
      <Box align="center" pt={16} mb={24}>
        <Text weight="medium" color="greenLight" mb={8}>
          Facility Limit 1
        </Text>
        <Text weight="medium" size="3xl">
          {facilityLimit}
        </Text>
      </Box>
      <Box align="center">
        <Button
          htmlType="submit"
          loading={isUpdateRequestMutating || isPassRequestMilestoneMutating}
        >
          Confirm & save
        </Button>
      </Box>
    </Form>
  )
}

const amountFieldRules = [
  ...FIELD_RULES,
  () => ({
    validator(_: any, value: any) {
      if (value) {
        return Promise.resolve()
      }
      return Promise.reject()
    },
  }),
]

const amountFieldRules0 = [
  ...FIELD_RULES,
  () => ({
    validator(_: any, value: any) {
      if (!!value || value === 0) {
        return Promise.resolve()
      }
      return Promise.reject()
    },
  }),
]
